<template>
  <section class="max-w-[1440px] mx-auto px-4 sm:px-8 py-2 sm:py-4">
    <slot />
  </section>
</template>
